import DF from 'DisplayFramework';
import PropList from 'pages/ProposalV3/PropList';
import React from 'react';

const DealerPayment = () => {
  const clientname = localStorage?.getItem('name');
  return (
    <DF.Provider pagcode="proplist">
    <PropList
      clientname={clientname ?? ''}
      phase="PROD"
      onSelect={undefined}
      hideExtraAction
      PropOrProd="PROD"
      flagPropWithCtreference={undefined}
    />
    </DF.Provider>
  );
};

export default DealerPayment;
